import {
  useFeatureFlagsQuery,
  FeatureFlagsQuery,
} from '@hook/useFlags/gql/graphql.v5.generated';


const defaultFlags: FeatureFlagsQuery['settings']['featureFlags'] = {
  multiplePriceChangeEnabled: false,
  splitRefundEnabled: false,
  schoolSaleEnabled: false,
  enableDiscountPagePersonalized: false,
  staticABTestFlag: false,
  checkQuantityForNewState: false,
  SHAF19375ScoreFormulaTest: false,
  SHAF18704NewTopProductsAlgorithm: false,
  SHAF19305NewBuyerAb: false,
  SHAF19515NewPhoneNumberReveal: false,
  SHAF19434GoogleOneTapLoginEnabled: false,
  SHAF19654KviAb: false,
  PRODUCTDetailsSpaEnabled: false,
  SHAF19621CheckoutAuthorizationEnabled: false,
  SHAF20278CheckoutRequiredEmailEnabled: false,
  SHAF20305ScoreFormula7Test: false,
  SHAF21020OrderAppPayEnabled: false,
  SHAF21020SmartAppPayEnabled: false,
  SHAF21020BalanceAppPayEnabled: false,
  SHAF21020PromotionAppPayEnabled: false,
  SHAF20467ScoreFormula8Test: false,
  SHAF20715MarkAllNotificationsAsReadEnabled: false,
  SHAF20847ReturnOrderEnabled: false,
  SHAF20611ScoreFormula10Test: false,
};

export const useFlags = (): typeof defaultFlags => {
  const { data, loading, error } = useFeatureFlagsQuery({
    context: { batch: true, v5: true },
  });

  if (loading || error || !data) {
    return defaultFlags;
  }

  return data.settings.featureFlags;
};

export const useFlagsWithLoadingState = () => {
  const { data, loading, error } = useFeatureFlagsQuery({
    context: { batch: true, v5: true },
  });

  return {
    flags: (error || !data) ? defaultFlags : data.settings.featureFlags,
    loading,
  };
};
